import styled from '@emotion/styled'
import { css } from '@emotion/react'

const Container = styled.section`
  & {
    .container {
      width: ${({ theme }) => theme.size.width[90]};
      max-width: ${({ theme }) => theme.size.width[900]};
      margin: auto;
    }

    .image-container {
      position: relative;
      padding: 0;
      width: 70%;
      margin: auto;
      padding-top: ${(582 / 1113) * 80}%;
      transition: ${({ theme }) => theme.style.transitionTime[400]} opacity;
    }

    .image-container > * {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }

    .container > h1 {
      color: ${({ theme }) => theme.colors.secondary[900]};
      font-size: var(--fs-500);
      font-weight: 700;
      line-height: normal;
      letter-spacing: 1px;
      margin: 0 0 40px 0;
      text-align: center;
    }

    ${({ theme }) =>
      css(
        theme.size.mq({
          '.container > h1': {
            fontSize: [
              'var(--fs-400)',
              'var(--fs-570)',
              'var(--fs-570)',
              'var(--fs-700)',
            ],
          },
          '.container': {
            padding: [
              '80px 0 110px 0',
              '80px 0 110px 0',
              '80px 0 110px 0',
              '130px 0 160px 0',
            ],
          },
        }),
      ).styles}
  }
`

export default Container
